import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomirajcab() {



    const cardData = {




keyword: "Belgaum to Miraj Cab",

headingDescription: "Belgaum Taxi Service provides comfortable, reliable, and affordable Belgaum to Miraj cab services for business travel, family visits, medical trips, shopping, railway transfers, educational purposes, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Miraj, we offer safe and convenient transportation with professional drivers and well-maintained vehicles. Our fleet includes Swift Dzire, Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, corporate travelers, and groups. We provide doorstep pickup and drop, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth and comfortable journey. Belgaum Taxi Service connects passengers between Belgaum and Miraj with dependable cab solutions for medical visits, business meetings, family functions, shopping trips, and personal travel. With experienced chauffeurs, clean vehicles, timely service, and customer-focused support, we make your Belgaum to Miraj taxi journey safe, convenient, and stress-free. Whether you are traveling for a short visit or planning further connectivity towards Maharashtra destinations, our cab service offers a comfortable travel experience according to your requirements.",

topPlaces: [
  {
    title: "Miraj",
    description: "Miraj is a well-known city in Maharashtra famous for its music tradition, healthcare facilities, railway connectivity, and commercial activities. It is a popular destination for travelers from Belgaum."
  },
  {
    title: "Sangli",
    description: "Sangli is a major city near Miraj known for agriculture, industries, temples, sugar production, and business activities. It is an important destination for corporate and family travel."
  },
  {
    title: "Ganpati Temple, Sangli",
    description: "The Ganpati Temple in Sangli is a famous religious attraction known for its spiritual importance and beautiful architecture, attracting devotees throughout the year."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a historic Maharashtra city famous for Mahalaxmi Temple, traditional markets, cuisine, cultural heritage, and business centers."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a historic hill fort near Kolhapur known for Maratha history, scenic views, and peaceful surroundings, making it a popular sightseeing destination."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is a famous pilgrimage destination near Miraj and Sangli, known for the Datta Temple and religious significance among devotees."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and business opportunities."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment areas, and tourist attractions. Comfortable cabs provide convenient long-distance connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination famous for beaches, resorts, churches, and sightseeing attractions. Travelers often combine Belgaum and Goa routes for leisure trips."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a nature and adventure destination near Belgaum known for wildlife sanctuary, river rafting, forests, and outdoor activities."
  }
],




  "services": [
    {
      "name": "Belgaum to Miraj Cab",
      "description": "Book Belgaum to Miraj Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Enjoy convenient transportation between Belgaum and Miraj with Sedan, Ertiga, Innova Crysta, and SUV cab options. Our cab services are ideal for family trips, business travel, local transfers, sightseeing, and personal journeys with flexible one way and round trip booking options."
    },
    {
      "name": "Belgaum to Miraj Taxi",
      "description": "Choose Belgaum to Miraj Taxi for affordable and convenient travel solutions with experienced drivers and comfortable vehicles. Travel hassle-free with clean AC cars, doorstep pickup, flexible schedules, and reliable taxi services. Suitable for passengers travelling for work, family visits, medical appointments, shopping, and other personal requirements."
    },
    {
      "name": "Belgaum to Miraj Cab Service",
      "description": "Hire Belgaum to Miraj Cab Service for smooth intercity transportation with professional chauffeurs and premium travel facilities. Get reliable pickup, comfortable seating, transparent pricing, and multiple vehicle options for your journey. Our cab service is suitable for individuals, families, corporate travelers, and groups travelling between Belgaum and Miraj."
    },
    {
      "name": "Belgaum to Miraj Taxi Service",
      "description": "Book Belgaum to Miraj Taxi Service for comfortable and dependable outstation travel. Enjoy experienced drivers, well-maintained vehicles, AC comfort, and flexible travel plans. Whether you need a one way taxi, round trip cab, or private vehicle hire, we provide convenient transportation solutions for every travel need."
    },
    {
      "name": "Belgaum to Miraj One Way Cab",
      "description": "Reserve Belgaum to Miraj One Way Cab for economical single-direction travel without return charges. Get direct transportation with professional drivers, comfortable cars, and timely pickup services. One way cabs are perfect for passengers who need convenient travel from Belgaum to Miraj at affordable rates."
    },
    {
      "name": "Belgaum to Miraj One Way Taxi",
      "description": "Choose Belgaum to Miraj One Way Taxi for private and comfortable point-to-point transportation. Enjoy clean vehicles, skilled chauffeurs, flexible departure timings, and hassle-free booking. Ideal for business trips, family travel, personal visits, and quick transfers between Belgaum and Miraj."
    },
    {
      "name": "Belgaum to Miraj Cab Booking",
      "description": "Complete Belgaum to Miraj Cab Booking with easy reservation facilities and multiple vehicle choices. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your passenger capacity and comfort requirements. Enjoy reliable drivers, doorstep pickup, and smooth travel experience for your journey."
    },
    {
      "name": "Belgaum to Miraj Taxi Booking",
      "description": "Book Belgaum to Miraj Taxi Booking services for convenient and reliable transportation. Get professional chauffeur-driven taxis with affordable fares, comfortable seating, and flexible travel options. Our taxi services are suitable for family trips, corporate travel, airport transfers, and outstation journeys."
    },
    {
      "name": "Belgaum to Miraj Car Rental",
      "description": "Choose Belgaum to Miraj Car Rental for comfortable chauffeur-driven vehicles with flexible rental options. Hire a car for personal travel, business trips, family journeys, and sightseeing requirements. Our rental services include clean vehicles, experienced drivers, and convenient pickup facilities."
    },
    {
      "name": "Belgaum to Miraj Outstation Cab",
      "description": "Book Belgaum to Miraj Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with professional chauffeurs, AC vehicles, and flexible trip plans. Our outstation cabs are suitable for families, tourists, corporate travelers, and individuals travelling between Belgaum and Miraj."
    },
    {
      "name": "Belgaum to Miraj Innova Crysta Cab",
      "description": "Travel with Belgaum to Miraj Innova Crysta Cab for premium comfort, spacious interiors, and smooth long-distance journeys. Innova Crysta is perfect for families, groups, corporate travelers, and passengers carrying extra luggage. Enjoy luxury seating, experienced drivers, and reliable cab service."
    },
    {
      "name": "Belgaum to Miraj Ertiga Cab",
      "description": "Book Belgaum to Miraj Ertiga Cab for spacious and affordable family travel. Ertiga provides comfortable seating, AC facilities, and sufficient luggage space for small groups. It is suitable for family trips, corporate travel, airport transfers, and outstation transportation."
    },
    {
      "name": "Belgaum to Miraj Sedan Cab",
      "description": "Choose Belgaum to Miraj Sedan Cab for economical and comfortable transportation with professional chauffeurs. Sedan cabs are ideal for couples, small families, and business travelers looking for a smooth AC ride. Enjoy clean cars, affordable pricing, and reliable service."
    },
    {
      "name": "Belgaum to Miraj Round Trip Cab",
      "description": "Hire Belgaum to Miraj Round Trip Cab for flexible return travel with affordable packages and dedicated vehicles. Perfect for business visits, family trips, sightseeing, and weekend travel plans. Enjoy comfortable rides, experienced drivers, and convenient scheduling throughout your journey."
    },
    {
      "name": "Belgaum to Miraj Private Taxi",
      "description": "Book Belgaum to Miraj Private Taxi for a personalized travel experience with complete privacy and comfort. Get a dedicated vehicle with professional chauffeurs, clean interiors, AC facilities, and flexible pickup options for individuals, families, and corporate passengers."
    },
    {
      "name": "Cheap Belgaum to Miraj Cab",
      "description": "Find Cheap Belgaum to Miraj Cab services offering affordable fares without compromising safety and comfort. Choose budget-friendly Sedan, Ertiga, or premium vehicles according to your requirements. Enjoy reliable transportation with experienced drivers and convenient booking options."
    },
    {
      "name": "Best Belgaum to Miraj Cab Service",
      "description": "Choose Best Belgaum to Miraj Cab Service for dependable travel with premium vehicles and professional chauffeurs. Experience safe journeys, timely pickup, comfortable seating, and flexible booking options. Our services are designed for families, business travelers, tourists, and long-distance passengers."
    },
    {
      "name": "Online Belgaum to Miraj Cab Booking",
      "description": "Book Online Belgaum to Miraj Cab Booking with simple reservations and quick vehicle selection. Choose your preferred cab category and travel schedule according to your convenience. Enjoy online booking facilities, professional drivers, and comfortable outstation travel solutions."
    },
    {
      "name": "Belgaum to Miraj Taxi Fare",
      "description": "Check Belgaum to Miraj Taxi Fare based on vehicle type, trip duration, and travel requirements. Select from Sedan, Ertiga, Innova Crysta, and SUV options with flexible pricing. Get transparent fares, comfortable rides, and professional chauffeur services for your journey."
    },
    {
      "name": "Belgaum to Miraj Car Hire",
      "description": "Hire Belgaum to Miraj Car Hire services for reliable chauffeur-driven transportation. Choose a vehicle based on your comfort, passenger count, and luggage needs. Our car hire services are suitable for family trips, corporate travel, sightseeing, and personal journeys."
    },
    {
      "name": "Belgaum to Miraj Cab Price",
      "description": "Get affordable Belgaum to Miraj Cab Price options with different vehicle categories and flexible travel plans. Choose economical Sedan cabs or spacious Innova Crysta and SUV vehicles. Enjoy transparent pricing, comfortable travel, and reliable chauffeur assistance."
    },
    {
      "name": "Belgaum to Miraj Family Cab",
      "description": "Book Belgaum to Miraj Family Cab for safe and comfortable travel with your loved ones. Spacious vehicles, professional drivers, AC comfort, and luggage-friendly interiors make your journey convenient. Ideal for family visits, vacations, and weekend travel."
    },
    {
      "name": "Belgaum to Miraj Corporate Taxi",
      "description": "Choose Belgaum to Miraj Corporate Taxi for professional business transportation solutions. Our corporate cabs provide punctual service, executive vehicles, experienced chauffeurs, and customized travel options for meetings, employee travel, and business requirements."
    },
    {
      "name": "Belgaum to Miraj Airport Transfer",
      "description": "Book Belgaum to Miraj Airport Transfer service for smooth airport pickup and drop transportation. Enjoy timely service, comfortable AC vehicles, professional drivers, and convenient travel arrangements for business travelers and families."
    },
    {
      "name": "Belgaum to Miraj Cab Fare",
      "description": "Plan your journey with Belgaum to Miraj Cab Fare options designed for different travel requirements. Choose from multiple vehicle categories and enjoy affordable rates with comfortable rides, experienced chauffeurs, and flexible booking options."
    },
    {
      "name": "Belgaum to Miraj Taxi Near Me",
      "description": "Find Belgaum to Miraj Taxi Near Me services for quick and convenient travel arrangements. Get access to reliable private taxis with professional drivers, comfortable vehicles, and flexible pickup locations for your journey from Belgaum to Miraj."
    },
    {
      "name": "Belgaum to Miraj Outstation Taxi",
      "description": "Book Belgaum to Miraj Outstation Taxi for safe and reliable long-distance transportation. Enjoy spacious seating, AC comfort, experienced chauffeurs, and flexible travel options for families, corporate passengers, tourists, and individual travelers."
    },
    {
      "name": "Belgaum to Miraj Travel by Cab",
      "description": "Enjoy Belgaum to Miraj Travel by Cab with comfortable private transportation and professional driver assistance. Plan your trip with one way or round trip options and experience safe, convenient, and relaxing travel between Belgaum and Miraj."
    }
  ],
  "tableData": [
    ["Belgaum to Miraj Cab", "Belgaum to Miraj Taxi"],
    ["Belgaum to Miraj Cab Service", "Belgaum to Miraj Taxi Service"],
    ["Belgaum to Miraj One Way Cab", "Belgaum to Miraj One Way Taxi"],
    ["Belgaum to Miraj Cab Booking", "Belgaum to Miraj Taxi Booking"],
    ["Belgaum to Miraj Car Rental", "Belgaum to Miraj Outstation Cab"],
    ["Belgaum to Miraj Innova Crysta Cab", "Belgaum to Miraj Ertiga Cab"],
    ["Belgaum to Miraj Sedan Cab", "Belgaum to Miraj Round Trip Cab"],
    ["Belgaum to Miraj Private Taxi", "Cheap Belgaum to Miraj Cab"],
    ["Best Belgaum to Miraj Cab Service", "Online Belgaum to Miraj Cab Booking"],
    ["Belgaum to Miraj Taxi Fare", "Belgaum to Miraj Car Hire"],
    ["Belgaum to Miraj Cab Price", "Belgaum to Miraj Family Cab"],
    ["Belgaum to Miraj Corporate Taxi", "Belgaum to Miraj Airport Transfer"],
    ["Belgaum to Miraj Cab Fare", "Belgaum to Miraj Taxi Near Me"],
    ["Belgaum to Miraj Outstation Taxi", "Belgaum to Miraj Travel by Cab"]
  ],





whychoose: [
  {
    WhyChooseheading: "Convenient Belgaum to Miraj Cab Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Miraj with a dependable taxi service offering professional drivers, clean vehicles, and flexible travel options for personal and business requirements."
  },
  {
    WhyChooseheading: "Smooth City-to-City Connectivity",
    WhyChoosedescription: "Enjoy direct transportation between Belgaum and Miraj with convenient pickup and drop facilities that save time and make your journey stress-free."
  },
  {
    WhyChooseheading: "Multiple Cab Categories Available",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your passenger count, luggage needs, and comfort level."
  },
  {
    WhyChooseheading: "Perfect for Medical & Personal Travel",
    WhyChoosedescription: "Our Belgaum to Miraj taxis are suitable for hospital visits, family trips, business travel, railway transfers, and other personal transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Better Travel",
    WhyChoosedescription: "Professional chauffeurs ensure a smooth ride with proper route knowledge, punctual service, and focus on passenger comfort."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Trips",
    WhyChoosedescription: "Choose a one-way taxi for direct travel or arrange a return journey according to your preferred timing and schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Travel in well-maintained cars with hygienic interiors and comfortable seating for a pleasant journey from Belgaum to Miraj."
  },
  {
    WhyChooseheading: "Easy Booking Process",
    WhyChoosedescription: "Get quick assistance for fare details, vehicle availability, and cab reservations to plan your Belgaum to Miraj trip easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Miraj Cab Service?",
    answer: "Yes, we provide Belgaum to Miraj taxi services with comfortable vehicles and professional drivers for convenient travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Miraj?",
    answer: "Yes, one-way cab services are available for passengers who need direct travel between Belgaum and Miraj."
  },
  {
    question: "Which cars are available for Belgaum to Miraj travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles based on your requirements."
  },
  {
    question: "Is this cab service suitable for hospital visits in Miraj?",
    answer: "Yes, comfortable taxi options are available for medical travel, hospital visits, and family transportation requirements."
  },
  {
    question: "Can I book a return taxi from Miraj to Belgaum?",
    answer: "Yes, return journey cabs are available with flexible travel schedules according to your convenience."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private cab from Belgaum to Miraj?",
    answer: "Yes, private taxi services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are informed during booking."
  },
  {
    question: "Is Belgaum to Miraj taxi available anytime?",
    answer: "Yes, booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Miraj Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Patil",
    feedback: "The Belgaum to Miraj cab service was very convenient. The driver arrived on time, and the entire journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Desai",
    feedback: "We needed a comfortable cab for a family visit to Miraj. The vehicle was clean, the driver was polite, and the service was excellent.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Miraj Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-miraj-cab.webp",
  "description":
    "Book Belgaum to Miraj Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Miraj with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, medical visits, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-miraj-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Belgaum to Miraj Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Miraj Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Miraj with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Miraj Cab, Belgaum to Miraj Taxi, Belgaum to Miraj Cab Service, Belgaum to Miraj Taxi Service, Belgaum to Miraj One Way Cab, Belgaum to Miraj One Way Taxi, Belgaum to Miraj Cab Booking, Belgaum to Miraj Taxi Booking, Belgaum to Miraj Car Rental, Belgaum to Miraj Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomirajcab ;